import { ComponentChildren } from 'preact';
import { getBrand } from 'shared/campaign-brands';

type Props = {
  headline?: string;
  subtitle?: string;
  subtitleColor?: string;
  subtitle2?: string;
  logoUrl?: string;
  badge?: string;
  gradientFrom?: string;
  gradientTo?: string;
  brand?: string;
  children?: ComponentChildren;
};

function MiraseeLogo() {
  return (
    <svg
      width="160"
      height="52"
      viewBox="0 0 110 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="display: inline-block"
    >
      <path
        d="M22.46 35.68c-2.11 0-3.23-1.38-3.23-3.63V24.71c0-1.19-.68-1.74-1.46-1.74-1.47 0-2.77 1.58-3.65 2.55v10.14H9.63v-10.96c0-1.2-.68-1.74-1.47-1.74-1.47 0-2.77 1.58-3.65 2.55v10.14H0V19.38h4.42v3.1h.09c1.76-1.98 3.59-3.59 6.09-3.59.84 0 1.7.31 2.34.88.79.7 1.06 1.67 1.16 2.71h.02c1.76-1.98 3.59-3.59 6.09-3.59.84 0 1.7.31 2.34.88 1.07.94 1.19 2.38 1.19 3.74v8.25c0 .79.24 1.43 1.01 1.43.27 0 .5-.06.68-.18l.15.13c-.17 1.43-1.25 2.55-3.12 2.55z"
        fill="#fff"
      />
      <path
        d="M31.99 35.68c-2.13 0-3.26-1.38-3.26-3.63V19.42h4.51v12.39c0 .79.24 1.43 1.01 1.43.24 0 .5-.06.68-.18l.15.13c-.17 1.37-1.23 2.49-3.08 2.49z"
        fill="#fff"
      />
      <path
        d="M48.25 23.41c-.46-.15-.92-.22-1.39-.22-1.61 0-2.9 1.3-4.07 2.49v9.99h-4.51v-12.63c0-.68-.22-1.19-1.01-1.19-.24 0-.5.06-.7.18l-.15-.13c.18-1.65 1.56-2.49 3.08-2.49 1.8 0 3.04 1.1 3.04 2.99v.37h.09c1.34-1.94 2.64-3.83 5.08-3.83.24 0 .51.04.79.09l-.26 4.38z"
        fill="#fff"
      />
      <path
        d="M51.46 22.73c-.04-.22-.46-3.32-.46-3.32 1.34-.37 3.01-.5 4.97-.5 4.01 0 7.11 1.62 7.11 6.31l-.09 6.51c0 .92.27 1.49 1.06 1.49.28 0 .51-.06.7-.18l.15.13c-.15 1.37-1.21 2.49-3.08 2.49-2.07 0-3.04-1.83-3.19-2.99h-.09c-1.49 1.58-2.82 2.99-4.8 2.99-2.71 0-4.29-2.13-4.29-4.79 0-3.17 2.31-4.53 6.73-4.53.77 0 1.67.06 2.38.15v-1.38c0-1.98-1.17-2.95-3.15-2.95-1.89.02-2.46.22-3.94.57zm7.1 6.27c-.59-.13-1.25-.18-2.02-.18-2.02 0-2.82.79-2.82 1.94 0 .97.61 1.76 1.76 1.76 1.25 0 2.16-.84 3.08-1.74v-1.78z"
        fill="#fff"
      />
      <path
        d="M71.02 35.68c-2.92 0-4.6-1.1-4.6-3.23 0-.18 0-.37.04-.55l.24-.13c1.06.68 2.44 1.01 3.83 1.01 1.49 0 2.68-.51 2.68-1.8 0-1.1-1.06-1.12-2.62-1.89-2.13-1.06-3.89-2.24-3.89-5 0-2.46 2.07-5.15 6.86-5.15 1.3 0 2.49.13 3.56.31l-.51 3.1c-.84-.28-1.98-.46-3.01-.46-1.65 0-2.53.68-2.53 1.58 0 1.01 1.17 1.65 2.7 2.42 2.03 1.01 3.99 1.67 3.99 4.44 0 2.26-1.69 5.35-6.73 5.35z"
        fill="#fff"
      />
      <path
        d="M93.78 26.58l-10.29 1.43c.37 3.01 2.4 4.6 5.83 4.6 1.21 0 2.68-.22 3.69-1.01l.22.15c.04.18.04.84.04 1.03 0 1.3-2.71 2.9-4.95 2.9-5.24 0-9.15-2.95-9.15-8.34 0-4.93 3.08-8.4 8.03-8.4 3.92 0 6.67 2.46 6.67 6.4 0 .42-.04.8-.09 1.24zm-6.97-5.06c-2.4 0-3.19 1.76-3.37 3.96l6.14-.94c0-1.63-.88-3.02-2.77-3.02z"
        fill="#fff"
      />
      <path
        d="M109.91 26.58l-10.29 1.43c.37 3.01 2.4 4.6 5.83 4.6 1.21 0 2.68-.22 3.69-1.01l.22.15c.04.18.04.84.04 1.03 0 1.3-2.71 2.9-4.95 2.9-5.24 0-9.15-2.95-9.15-8.34 0-4.93 3.08-8.4 8.03-8.4 3.92 0 6.67 2.46 6.67 6.4 0 .42-.02.8-.09 1.24zm-6.97-5.06c-2.4 0-3.19 1.76-3.37 3.96l6.14-.94c0-1.63-.88-3.02-2.77-3.02z"
        fill="#fff"
      />
      <path
        d="M65.65 4.88c.09.04.31.13.33.26 0 .02-.02.02-.02.02-.22-.04-.4.13-.55.27-.17.15-.33.3-.51.42-.39.24-.81.42-1.25.55-.11.04-.22.06-.31.09-.61.17-1.25.24-1.87.09-.68-.17-1.3-.6-1.62-1.24 0-.02 0-.02.02-.02.51.44 2.07-.04 2.07-.04-1.45-1.3-.37-3.17-2.02-5.28 2.7.39 3.26 4.4 3.26 4.4 1.74-.92 2.4-3.54 2.4-3.56-.02.07.06.24.07.29.02.11.06.22.07.33.04.2.06.4.07.6.02.33 0 .66-.06.99-.09.46-.26.9-.51 1.28-.07.11-.33.33-.33.46 0 .06-.02.04.02.07 0 .02.53-.05.71 0z"
        fill="#70D44B"
      />
      <path
        d="M40.66 5.45s-.75 2.95 1.01 5.3c-1.28-.28-2.68-.59-2.68-.59s.35 2.62 3.3 3.3v-1.45s1.58.13 2.42-1.03c.22 0 .46-.2.7-.02 0 0-.15-.53-.53-.73-.44-.26-1.17.18-1.17.18.06-.04-.47-3.3-3.04-4.96z"
        fill="#FFC600"
      />
      <path
        d="M28.8 13.07c-.62 1.06.55 2.11.55 2.11l.4-1.28s.9 1.89 5.28 1.72c-.82-.84-2.82-2.86-2.82-2.86l.5-.75s.29-.17.51 0c.22.17-.26-.73-.83-.73-.82 0-2.53 1.8-3.59 1.8z"
        fill="#00ABC8"
      />
      <path
        d="M50.65 9.17c.35-.72.57-.95.7-.88 1.39 1.49 2.55.9 3.78 1.58.02 0 .04-.02.02-.02-.48-.46-.49-1.61-1.45-2.24-.06-.04-.13-.11-.11-.18.04-.13.33-.44.35-.48.44-.4.44-.29.83-.35.04 0 .04-.06 0-.06-.6-.29-1.36-.22-1.98-.02-.82.26-1.34.51-2.16 1.23-.15.13-1.21.39-1.21.39s-.15 1.08 1.24 1.02z"
        fill="#FF6B00"
      />
    </svg>
  );
}

function WaveSvg() {
  return (
    <div class="campaign-hero__wave" style="color: var(--m-hero-wave-fill)">
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M0,35 C480,75 960,0 1440,40 L1440,80 L0,80 Z" />
      </svg>
    </div>
  );
}

export function CampaignHero({
  headline,
  subtitle,
  subtitleColor,
  subtitle2,
  logoUrl,
  badge,
  gradientFrom,
  gradientTo,
  brand,
  children,
}: Props) {
  // Only override CSS --m-hero-gradient if custom (non-Mirasee-brand) colors are set
  const isBrandGradient =
    !gradientFrom || !gradientTo || (gradientFrom === '#0089bd' && gradientTo === '#013ea6');
  const style = isBrandGradient
    ? undefined
    : `background: linear-gradient(135deg, ${gradientFrom} 0%, ${gradientTo} 100%)`;

  const brandDef = getBrand(brand);
  const resolvedLogoUrl = logoUrl || brandDef.defaultLogoUrl;
  const isMirasee = !brand || brand === 'mirasee';

  return (
    <div class="campaign-hero" style={style}>
      <WaveSvg />
      <div class="campaign-hero__logo campaign-hero__logo--white">
        {resolvedLogoUrl ? (
          <img src={resolvedLogoUrl} alt="Logo" />
        ) : isMirasee ? (
          <MiraseeLogo />
        ) : undefined}
      </div>
      {headline && <h1 class="campaign-hero__title">{headline}</h1>}
      {subtitle && (
        <p
          class="campaign-hero__subtitle"
          style={subtitleColor ? `color: ${subtitleColor}` : undefined}
        >
          {subtitle}
        </p>
      )}
      {subtitle2 && (
        <p
          class="campaign-hero__subtitle campaign-hero__subtitle--line2"
          style={subtitleColor ? `color: ${subtitleColor}` : undefined}
        >
          {subtitle2}
        </p>
      )}
      {badge && (
        <div style="margin-top: 20px">
          <button
            type="button"
            class="price-badge"
            onClick={() => {
              const el = document.querySelector('#checkout');
              if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            {badge}
          </button>
        </div>
      )}
      {children}
    </div>
  );
}
